import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

export const routes: Routes = [
    {
        path: 'login',
        loadChildren: () => import('@modules/auth/login/login-routing.module').then((m) => m.LoginRoutingModule)
    },
    {
        path: 'no-parking-zones',
        loadChildren: () =>
            import('modules/no-parking-zones/no-parking-zones-routing.module').then(
                (m) => m.NoParkingZonesRoutingModule
            )
    },
    {
        path: 'realtime-data-map',
        loadChildren: () =>
            import('modules/realtime-data-map/realtime-data-map-routing.module').then(
                (m) => m.RealtimeDataMapRoutingModule
            )
    },
    {
        path: 'dashboard',
        loadChildren: () =>
            import('@modules/vehicle-sharing-choropleths/vehicle-sharing-choropleths-routing.module').then(
                (m) => m.VehicleSharingChoroplethsRoutingModule
            )
    },
    {
        path: 'version',
        loadChildren: () => import('modules/utility/utility-routing.module').then((m) => m.UtilityRoutingModule)
    },
    {
        path: 'mobility-hubs',
        loadChildren: () =>
            import('@modules/mobility-hubs/mobility-hub-routing.module').then((m) => m.MobilityStationsRoutingModule)
    },
    {
        path: 'help-center',
        loadChildren: () =>
            import('modules/help-center/help-center-routing.module').then((m) => m.HelpCenterRoutingModule)
    },
    {
        path: '**',
        redirectTo: '/dashboard'
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {}
